export default "__VITE_ASSET__DZNpOE7___"